﻿$.fn.dxCtrlEmailData = function custom_dxCtrlEmailData(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlemaildata dx-ctrl");
        this.createInstance(new cdxCtrlEmailData(this, option));
    }
    return this;
}

window.cdxCtrlEmailData = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }
    if (typeof option.allowSup == 'undefined') option.allowSup = true
    if (typeof option.value == 'undefined') option.value = ""

    var $TdLib = null
    var $TdModif = null
    var $TdSupp = null
    var $TdNew = null
    function mConstruit() {
        container.empty();
        container.css({
            "border": theme.border,
            "padding": "5px"
        })

        if (typeof option.txtTooltip != 'undefined' && option.txtTooltip.length > 0) {
            container.attr("title",option.txtTooltip)
            //$("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: container, position: "top", contentTemplate: function (contentElement) { $("<div style='font-size:110%;'>" + option.txtTooltip + "</div>").appendTo(contentElement); } }).dxCtrlTooltipHoverTarget("instance");
        }

        var $Table = $("<table style='width:100%'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        $TdLib = $("<td style='width:100%;'/>").appendTo($Tr)
        $TdModif = $("<td style='width:1px;'/>").appendTo($Tr)
        $("<div/>").appendTo($TdModif).dxCtrlButton({
            height: 36,
            width: 36,
            icon: "fas fa-pen",
            txtTooltip: option.tooltipModif, //"Modifier la signature",
            onClick: function (e) {
                mShowModifSignature()
            }
        }).dxCtrlButton("instance")
        $TdSupp = $("<td style='width:1px;'/>").appendTo($Tr)
        $("<div/>").appendTo($TdSupp).dxCtrlButton({
            height: 36,
            width: 36,
            icon: "fas fa-window-close",
            txtTooltip: option.tooltipSupp, //"Supprimer la signature",
            onClick: function (e) {
                var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                    target: $TdSupp,
                    contentTemplate: function (contentElement) {
                        contentElement.css("padding", "24px");
                        $("<div style='padding-bottom:15px'>Cette signature sera supprimé définitivement.</div>").appendTo(contentElement)
                        $("<div/>").appendTo(contentElement).dxCtrlButton({
                            text: "confirmez la suppression",
                            onClick: function (e) {
                                option.value = null
                                mDisplayHideButton()
                                if (typeof option.onValueChanged != 'undefined') option.onValueChanged(option.value)
                                tt.hide();
                            }
                        });
                    }
                }).dxCtrlTooltip("instance");
                tt.show();
            }
        }).dxCtrlButton("instance")
        $TdNew = $("<td style='width:1px;'/>").appendTo($Tr)
        $("<div/>").appendTo($TdNew).dxCtrlButton({
            height: 36,
            width: 36,
            icon: "fas fa-certificate",
            txtTooltip: option.tooltipNew, //"Créer une nouvelle signature",
            onClick: function (e) {
                mShowModifSignature()
            }
        }).dxCtrlButton("instance")

        mDisplayHideButton()
    }

    function mDisplayHideButton() {
        if (option.value == null || option.value.length == 0) {
            $TdModif.hide()
            $TdSupp.hide()
            $TdNew.show()
        } else {
            $TdModif.show()
            if (option.allowSup) $TdSupp.show()
            $TdNew.hide()
        }
        if (!option.allowSup) $TdSupp.hide()

        option.rempliTxtLib($TdLib, option.value)
    }

    function mShowModifSignature() {
        var dxCtrlSignature = null;
        var pop = $("<div/>").appendTo($DivGeneral).dxCtrlPopupBase({
            title: option.titlePopupEmail, //"Signature",
            width: 700,
            height: "100%",
            showMaximize: true,
            dragEnabled: false,
            position: {
                my: "right top",
                at: "right top",
                of: "body"
            },
            contentTemplate: function (contentElement) {
                contentElement.css("padding", "5px")
                dxCtrlEmailBase64 = $("<div style='height:100%;width:100%;'/>").appendTo(contentElement).dxCtrlContentEmailBase64({
                    bddCtrl: option.bddCtrl,
                    data64: option.value,
                    data64Default: option.dataDefault,
                    showObjet: option.showObjet,
                    hideAddFile: option.hideAddFile
                }).dxCtrlContentEmailBase64("instance")
            },
            onHiding: function (e) {
                dxCtrlEmailBase64.mStopSaveAuto(function (base64String) {
                    if (typeof base64String != 'undefined') {
                        option.value = base64String
                        mDisplayHideButton()
                        if (typeof option.onValueChanged != 'undefined') option.onValueChanged(option.value)
                    }
                })
            }
        }).dxCtrlPopupBase("instance")
        pop.show();
    }

    this.element = function () { return container }

    mConstruit();
}